import * as React from 'react';
import { gql, useQuery } from '@apollo/client';

export default function(props) {

    let seo = {...props.seo};
    
    const findAndReplace = (el, prop, targetAttr) => {
        if (seo[prop] && el) {
            if (targetAttr) {
                if (el.getAttribute('targetAttr') !== seo[prop]) {
                    el.setAttribute(targetAttr, seo[prop]);
                }
            } else if (el.innerText !== seo[prop]) {
                el.innerText = seo[prop];
            }
        }
    };

    if (seo) {
        findAndReplace(document.getElementsByTagName('title')[0], 'title');
        findAndReplace(document.querySelector('meta[name=description]'), 'metaDescription', 'content');
        findAndReplace(document.querySelector('meta[name=keywords]'), 'metaKeywords', 'content');
        findAndReplace(document.querySelector('meta[property="og:title"]'), 'ogTitle', 'content');
        findAndReplace(document.querySelector('meta[property="og:description"]'), 'ogDescription', 'content');
        findAndReplace(document.querySelector('meta[property="og:image"]'), 'ogImage', 'content');
        findAndReplace(document.querySelector('meta[property="og:url"]'), 'canonical', 'content');
        findAndReplace(document.querySelector('meta[name="twitter:title"]'), 'twTitle', 'content');
        findAndReplace(document.querySelector('meta[name="twitter:description"]'), 'twDescription', 'content');
        findAndReplace(document.querySelector('meta[name="twitter:image"]'), 'twImage', 'content');
        findAndReplace(document.querySelector('link[rel="canonical"]'), 'canonical', 'href');
    }

    return null;
}